import { useEffect } from "react";
import { Download, X } from "lucide-react";
import { getMediaFileName, getMediaType } from "../lib/media";

const MediaPreviewModal = ({ media, onClose }) => {
  const url = media?.url || "";
  const title = media?.title || getMediaFileName(url);
  const type = media?.type || getMediaType(url);

  useEffect(() => {
    const handleKeydown = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", handleKeydown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener("keydown", handleKeydown);
    };
  }, [onClose]);

  if (!url) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-[rgba(6,10,18,0.84)] px-4 py-6 backdrop-blur-[2px]"
      role="dialog"
      aria-modal="true"
      aria-label={`Preview ${title}`}
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-6xl pt-14"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="absolute right-0 top-0 z-20 flex items-center gap-2">
          <a
            href={url}
            download={getMediaFileName(url, title)}
            target="_blank"
            rel="noreferrer"
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-[rgba(31,39,56,0.94)] text-white shadow-[0_18px_40px_rgba(0,0,0,0.32)] transition hover:bg-[rgba(53,63,82,0.96)]"
            aria-label={`Download ${title}`}
          >
            <Download className="h-5 w-5" />
          </a>
          <button
            type="button"
            onClick={onClose}
            className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-[rgba(31,39,56,0.94)] text-sm font-semibold text-white shadow-[0_18px_40px_rgba(0,0,0,0.32)] transition hover:bg-[rgba(53,63,82,0.96)]"
            aria-label="Tutup preview"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <div className="overflow-hidden rounded-[28px] border border-white/10 bg-[rgba(14,20,33,0.92)] shadow-[0_28px_80px_rgba(0,0,0,0.4)]">
          <div className="max-h-[85vh] overflow-auto p-3 sm:p-5">
            {type === "video" ? (
              <video
                src={url}
                controls
                autoPlay
                className="mx-auto h-auto max-h-[78vh] w-auto max-w-full rounded-[22px] object-contain"
              >
                Browser Anda tidak mendukung preview video.
              </video>
            ) : (
              <img
                src={url}
                alt={title}
                className="mx-auto h-auto max-h-[78vh] w-auto max-w-full rounded-[22px] object-contain"
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MediaPreviewModal;
